import { z } from 'zod';

import { SECTOR_IDS, WindowKeySchema, FilterKeySchema } from './enums';
import { SectorAggregateSchema } from './sector.schema';
import { SecuritySchema } from './security.schema';

/**
 * Defensive ceiling for dashboard rows (full filtered set, not paginated).
 * Sized ABOVE the plan's own >2 000-name re-architecture trigger (plan §4.4,
 * NFR-X3/X4) — `HttpRepository` parses responses against this schema, so a
 * ceiling below the admitted universe size fails the screen rather than
 * truncating it.
 */
export const ROWS_MAX = 2_500;

export const BreadthSchema = z.object({
  advancers: z.number().int().nonnegative(),
  decliners: z.number().int().nonnegative(),
  ratio: z.number(),
});
export type Breadth = z.infer<typeof BreadthSchema>;

/**
 * Dashboard composite payload (plan §3.2 · §6.6 `/v1/dashboard`).
 * Treemap geometry is client-side; this carries treemap-ready aggregates.
 */
export const DashboardPayloadSchema = z.object({
  window: WindowKeySchema,
  index: FilterKeySchema,
  rows: z.array(SecuritySchema).max(ROWS_MAX),
  sectors: z.array(SectorAggregateSchema).max(SECTOR_IDS.length),
  breadth: BreadthSchema,
});
export type DashboardPayload = z.infer<typeof DashboardPayloadSchema>;
